import React from 'react';
import withIcon from '../utilities/withIcon';

const IconKey = () => {
  return (
    <g>
      <path d="M5.622 0c3.106 0 5.623 2.44 5.623 5.45a5.29 5.29 0 0 1-.567 2.386l4.836 4.807a.728.728 0 0 1 .19.328l.019.095.27 2.065a.777.777 0 0 1-.753.869l-.114-.006-2.078-.27a.74.74 0 0 1-.353-.144l-.072-.063-5.004-4.972a5.768 5.768 0 0 1-1.997.353C2.517 10.898 0 8.458 0 5.45 0 2.44 2.517 0 5.622 0zm3.404 9.787 4.504 4.477.83.107-.107-.826-4.464-4.437a5.594 5.594 0 0 1-.763.679zm-3.404-8.3c-2.258 0-4.089 1.773-4.089 3.962s1.831 3.963 4.09 3.963c2.258 0 4.088-1.774 4.088-3.963s-1.83-3.963-4.089-3.963zm-.51 1.485c1.128 0 2.044.887 2.044 1.982 0 1.094-.916 1.981-2.045 1.981s-2.044-.887-2.044-1.981c0-1.095.915-1.982 2.044-1.982zm0 1.486a.503.503 0 0 0-.512.496c0 .273.229.495.511.495a.503.503 0 0 0 .511-.495.503.503 0 0 0-.51-.496z" />
    </g>
  );
};

export default withIcon(IconKey);
